import { Link } from 'react-router-dom'
import { TOPICS } from '../seo/topics'

export function GuideLinks({ current }: { current?: string }) {
  const topics = TOPICS.filter((topic) => topic.path !== current)
  return (
    <nav className="guide-links" aria-label="Jewish music guides">
      {topics.map((topic) => (
        <Link key={topic.path} to={topic.path}>
          {topic.nav}
        </Link>
      ))}
    </nav>
  )
}
